import styled, { css } from 'styled-components';
import LinkComponent from '@components/link';
import { RichTextContainer } from '@components/paragraphs/paragraphs.shared.styled';
import { generateScales } from '@helpers/generate-media-queries';

export const TickerContainer = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: ${theme.zIndex.navbar + 1};
    background: ${theme.colors.secondary};
    color: ${theme.colors.white};
    font-family: ${theme.fontFamily.text};
    font-weight: ${theme.fontWeights.normal};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-height: 3rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      min-height: unset;
    }
  `}
`;

export const TickerSpacer = styled.div`
  ${({ theme }) => css`
    height: 3rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      height: 2.5rem;
    }
  `}
`;

export const TickerContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    min-height: 3rem;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.75rem;
      padding: 0.75rem 2.5rem 0.75rem 1rem;
      min-height: 2.5rem;
    }

    p a {
      color: ${theme.colors.white};
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  `}
`;

export const TickerMessage = styled(RichTextContainer)`
  ${({ theme }) => css`
    flex: 1;
    margin: 0;

    p {
      margin: 0;
      color: ${theme.colors.white};
      font-size: 0.9rem;
      line-height: 1.4;
      text-align: center;

      ${generateScales('font-size', '0.85rem', '1rem', theme)}

      a {
        color: ${theme.colors.white} !important;
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }

    a {
      color: ${theme.colors.white} !important;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    strong {
      font-weight: ${theme.fontWeights.bold};
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      text-align: left;
    }
  `}
`;

export const TickerLink = styled(LinkComponent)`
  ${({ theme }) => css`
    background: rgba(255, 255, 255, 0.2);
    color: ${theme.colors.white};
    padding: 0.5rem 1rem;
    border-radius: 1.5rem;
    font-size: 0.85rem;
    font-weight: ${theme.fontWeights.normal};
    text-decoration: none;
    white-space: nowrap;
    transition: all 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-1px);
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 0.4rem 0.8rem;
      font-size: 0.8rem;
    }
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    background: none;
    border: none;
    color: ${theme.colors.white};
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    padding: 0.25rem;
    margin-left: 0.5rem;
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    &:focus {
      outline: 2px solid rgba(255, 255, 255, 0.5);
      outline-offset: 2px;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
      transform: none;
      font-size: 1.25rem;
      width: 1.75rem;
      height: 1.75rem;
    }
  `}
`;
